import { render, staticRenderFns } from "./RegisterStepTwo.vue?vue&type=template&id=c36aaac8&"
import script from "./RegisterStepTwo.vue?vue&type=script&lang=ts&"
export * from "./RegisterStepTwo.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterStepTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports